<div fxLayout="column" fxFill class="customer-plan-items-container">
  <div class="plan-inputs-area plan-config-card" *ngIf="typeCes !== typeCesEnum.SHOW">
    <div class="config-header" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8">
      <button
        mat-raised-button
        class="select-plan-button"
        [class.plan-selected]="selectedPlanName"
        (click)="onSystemSelect($event)"
        title="SELECIONAR PLANO">
        <mat-icon>search</mat-icon>
        <span *ngIf="!selectedPlanName">Selecionar plano</span>
        <span *ngIf="selectedPlanName">{{ selectedPlanName }}</span>
      </button>

      <span class="config-hint" *ngIf="!selectedPlanName && !editMode">
        Selecione um plano para configurar valores e limites.
      </span>

      <div *ngIf="editMode" fxLayout="row" fxLayoutGap="8" fxLayoutAlign="end center">
        <button
          mat-button
          class="cancel-button"
          (click)="cancelEdit()"
          title="CANCELAR EDIÇÃO">
          Cancelar edição
        </button>
        <button
          mat-raised-button
          color="primary"
          class="save-override-button"
          (click)="saveItem()"
          title="SALVAR">
          Salvar
        </button>
      </div>
    </div>

    <div class="config-fields" *ngIf="selectedPlanName || editMode">
      <div class="field-group">
        <span class="group-title">Valores do plano</span>
        <span class="group-hint">Valores herdados do plano. Edite para sobrescrever neste cliente.</span>
        <div fxLayout="row" fxLayoutGap="8" fxLayout.lt-sm="column">
          <app-input fxFlex [config]="getFieldConfig('monthlyValue')" [group]="form"></app-input>
          <app-input fxFlex [config]="getFieldConfig('adhesionFee')" [group]="form"></app-input>
        </div>
        <div fxLayout="row" fxLayoutGap="8" fxLayout.lt-sm="column">
          <app-input fxFlex [config]="getFieldConfig('deploymentValue')" [group]="form"></app-input>
          <app-input fxFlex [config]="getFieldConfig('dueDate')" [group]="form"></app-input>
        </div>
      </div>

      <div class="field-group" *ngIf="showDaysCountQuantity">
        <span class="group-title">Cobrança por dias corridos</span>
        <div fxLayout="row" fxLayoutGap="8" fxLayout.lt-sm="column">
          <app-input fxFlex [config]="getFieldConfig('daysCountQuantity')" [group]="form"></app-input>
        </div>
      </div>

      <div class="field-group">
        <span class="group-title">Limites</span>
        <div fxLayout="row" fxLayoutGap="8" fxLayout.lt-sm="column">
          <app-input fxFlex [config]="getFieldConfig('maxBranches')" [group]="form"></app-input>
          <app-input fxFlex [config]="getFieldConfig('maxUsers')" [group]="form"></app-input>
        </div>
      </div>
    </div>
  </div>

  <div class="items-area" fxFlex>
    <div class="table-container">
      <table mat-table #table [dataSource]="dataSource"
        class="mat-elevation-z0 plans-selected-table">
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef>Código</th>
          <td
            mat-cell
            *matCellDef="let element; let i = index"
            [ngClass]="i == indexSelect ? '' : 'code'">
            {{ element.code }}
          </td>
        </ng-container>

        <ng-container matColumnDef="planName">
          <th mat-header-cell *matHeaderCellDef>Plano</th>
          <td
            mat-cell
            *matCellDef="let element; let i = index"
            [ngClass]="i == indexSelect ? '' : 'system'">
            {{ element?.planName || element?.name || element?.system?.name || element?.system }}
          </td>
        </ng-container>

        <ng-container matColumnDef="terminalQuantity">
          <th mat-header-cell *matHeaderCellDef title="Quantidade de terminais">Terminais</th>
          <td mat-cell *matCellDef="let element">
            {{ element.terminalQuantity }}
          </td>
        </ng-container>

        <ng-container matColumnDef="monthlyValue">
          <th mat-header-cell *matHeaderCellDef>Mensalidade</th>
          <td mat-cell *matCellDef="let element">
            {{ element.monthlyValue | currency : "BRL" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dueDate">
          <th mat-header-cell *matHeaderCellDef title="Dia do mês de vencimento">Vencimento</th>
          <td mat-cell *matCellDef="let element">
            {{ element.dueDate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="adhesionFee">
          <th mat-header-cell *matHeaderCellDef title="Taxa de adesão">Adesão</th>
          <td mat-cell *matCellDef="let element">
            {{ element.adhesionFee | currency : "BRL" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="daysCountQuantity">
          <th mat-header-cell *matHeaderCellDef
            title="Quantidade de dias corridos">
            Dias corridos
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.daysCountQuantity }}
          </td>
        </ng-container>

        <ng-container matColumnDef="daysCountValue">
          <th mat-header-cell *matHeaderCellDef title="Valor por dia corrido">
            Valor/dia
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.daysCountValue | currency : "BRL" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="deploymentValue">
          <th mat-header-cell *matHeaderCellDef title="Valor de implantação">Implantação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.deploymentValue | currency : "BRL" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef class="createdAt">Criado em</th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.createdAt | date : "dd/MM/yy" }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="active">
          <th mat-header-cell *matHeaderCellDef class="status">Status</th>
          <td
            mat-cell
            *matCellDef="let element; let i = index"
            [ngClass]="i == indexSelect ? 'status-selected' : 'status'">
            <mat-icon *ngIf="element.active"
              class="item-icon-active">check</mat-icon>
            <mat-icon *ngIf="!element.active"
              class="item-icon-inactive">close</mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="remove">
          <th mat-header-cell *matHeaderCellDef>Ações</th>
          <td
            mat-cell
            *matCellDef="let element; let i = index"
            [ngClass]="i == indexSelect ? 'actions-selected' : 'actions'">
            <mat-icon
              class="item-icon-cancel"
              *ngIf="typeCes == typeCesEnum.EDIT && element.id && element.active"
              title="CANCELAR"
              (click)="cancelItem(i, element)">close</mat-icon>
            <mat-icon
              class="item-icon-remove"
              *ngIf="isEditable(i, element) && element.active"
              title="EDITAR"
              (click)="editItem(i, element)">edit</mat-icon>
            <mat-icon
              *ngIf="isRemovable(i, element) && typeCes !== typeCesEnum.SHOW"
              title="EXCLUIR"
              class="item-icon-remove"
              (click)="removeItem(i, element)">delete_outline</mat-icon>

            <mat-icon
              *ngIf="element?.systemModules?.length || element?.customerPlanAudits?.length"
              title="item-icon-info"
              class="item-icon-info"
              (click)="showInfo(i, element)">info</mat-icon>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
          class="table-row"></tr>
        <tr
          tabindex="999"
          #rowDef
          mat-row
          *matRowDef="let row; columns: displayedColumns; let i = index"
          [ngClass]="getNgClass(dataSource.data[i], i)"
          (click)="select(i)"
          [class.demo-row-is-clicked]="indexSelect === i"
          class="table-row"></tr>
      </table>
    </div>
  </div>

  <div class="total-area" fxLayout="row" fxLayoutAlign="end center">
    <span class="title-monthly-title">IMPLANT:</span>
    <span class="title-monthly-value">{{ getDeploymentValueTotal() | currency :
      "BRL" }}</span> &nbsp; | &nbsp;
    <span class="title-monthly-title">DIAS CORRIDOS:</span>
    <span class="title-monthly-value">{{ getDaysCountValueTotal() | currency :
      "BRL" }}</span> &nbsp; | &nbsp;
    <span class="title-monthly-title">TX.ADES:</span>
    <span class="title-monthly-value">{{ getAdhesionFeeTotal() | currency :
      "BRL" }}</span> &nbsp; | &nbsp;
    <span class="title-monthly-title">UNID:</span>
    <span class="title-monthly-value">{{ getMonthlyValueUnitTotal() | currency :
      "BRL" }}</span> &nbsp; | &nbsp;
    <span class="title-monthly-title">MENSAL:</span>
    <span class="title-monthly-value">{{ getMonthlyValuePartnerTotal() |
      currency : "BRL" }}</span> &nbsp; | &nbsp;
    <span class="title-monthly-title">TOTAL:</span>
    <span class="title-monthly-value">{{ getMonthlyValueTotal() | currency :
      "BRL" }}</span>
  </div>
</div>
